
import { FC, useContext, useRef, useState } from "react"
import { Link, useLocation, useParams } from "react-router-dom";

import StepperModal from "../stepperModal";

import { CASE_DETAIL_HEADER, HIDE_PATEINT_DOB_INITIALS } from "src/constants/manufacturer";
import { CaseDetailPropsType, QueryParamsState } from "./types";
import { isMobileOrTablet, isNotOlderThanOneYear, objectToQueryString } from "src/helpers";
import { useOnClickOutside } from "src/hooks/useClickOutside";
import { AuthContext } from "src/context/authContext";
import { ManufacturerSubHeaderProps } from "src/types/users";



const CaseDetail: FC<CaseDetailPropsType> = ({ baseUrl, searchParams, CaseDetailListType }): JSX.Element => {
  const [showingModal, setModal] = useState(false);
  const [selectedCaseId, updateSelectedCaseId] = useState<number>(0);
  const [infoIconIndex, changeInfoIconIndex] = useState<number>(-1);
  const [queryParams, updateQueryParams] = useState<QueryParamsState>({
    direction: "desc",
    sort_by: "case_id",
  });
  const {role, id,p_id} = useParams ();
  console.log("role", { role })
  console.log("id", { id })
  console.log("p_id", { p_id })
   const location = useLocation();
   console.log("location", location.pathname ,location.search ,location.state ,location.key )
    const params = new URLSearchParams(location.search);
    console.log("params", {}, params.get("p_id"))
   const { userData,sub_header } = useContext(AuthContext)
  const toggleIconRef = useRef<HTMLElement | null>(null);
  console.log("sub_header", { sub_header })

  useOnClickOutside(toggleIconRef, () => {
    changeInfoIconIndex(-1);
  });

  const openModal = (caseId: number) => {
    setModal(true);
    updateSelectedCaseId(caseId);
  };

  const changeIdOrder = (tableHeader: string) => {
    const updatedQueryParams: QueryParamsState = {
      sort_by: tableHeader,
      direction: tableHeader === queryParams.sort_by ? (queryParams.direction === "desc" ? "asc" : "desc") : "desc"
    };

    switch (updatedQueryParams.sort_by) {
      case "case_id":
        CaseDetailListType.sort((item1, item2) => {
          if (updatedQueryParams.direction === "asc")
            return Number(item1.case_id) - Number(item2.case_id);
          else
            return Number(item2.case_id) - Number(item1.case_id);
        });
        break;

      case "patient_id":
        CaseDetailListType.sort((item1, item2) => {
          if (updatedQueryParams.direction === "asc")
            return Number(item1.patient_id) - Number(item2.patient_id);
          else
            return Number(item2.patient_id) - Number(item1.patient_id);
        });
        break;

      case "bi_ct":
        CaseDetailListType.sort((item1, item2) => {
          if (updatedQueryParams.direction === "asc")
            return Number(item1.bi_ct) - Number(item2.bi_ct);
          else
            return Number(item2.bi_ct) - Number(item1.bi_ct);
        });
        break;

      case "qty":
        CaseDetailListType.sort((item1, item2) => {
          if (updatedQueryParams.direction === "asc")
            return Number(item1.qty || 0) - Number(item2.qty || 0);
          else
            return Number(item2.qty || 0) - Number(item1.qty || 0);
        });
        break;
      case "received":
        CaseDetailListType.sort((item1, item2) => {
          if (updatedQueryParams.direction === "asc")
            return (item1.received || "").localeCompare(item2.received || "");
          else
            return (item2.received || "").localeCompare(item1.received || "");
        });
        break;

      case "bi_completed":
        CaseDetailListType.sort((item1, item2) => {
          if (updatedQueryParams.direction === "asc")
            return (item1.bi_completed || "").localeCompare(item2.bi_completed || "");
          else
            return (item2.bi_completed || "").localeCompare(item1.bi_completed || "");
        });
        break;
      case "payer":
        CaseDetailListType.sort((item1, item2) => {
          if (updatedQueryParams.direction === "asc")
            return (item1.payer || "").localeCompare(item2.payer || "");
          else
            return (item2.payer || "").localeCompare(item1.payer || "");
        });
        break;
      case "case_status":
        CaseDetailListType.sort((item1, item2) => {
          if (updatedQueryParams.direction === "asc")
            return (item1.case_status || "").localeCompare(item2.case_status || "");
          else
            return (item2.case_status || "").localeCompare(item1.case_status || "");
        });
        break;
      case "provider.doc_name":
        CaseDetailListType.sort((item1, item2) => {
          if (updatedQueryParams.direction === "asc")
            return item1.provider.doc_name.localeCompare(item2.provider.doc_name);
          else
            return item2.provider.doc_name.localeCompare(item1.provider.doc_name);
        });
        break;
    }

    updateQueryParams(updatedQueryParams);
  };

  return (
    <>
      <div className={"col-12"}>
        <div className="card">
          <div className="card-header">
            <h1 className="heading-title text-center">Case Details</h1>
          </div>

          <div className="card-body p-0">
            <div className="table-responsive overflow-auto" style={{ minHeight: "50px", maxHeight: "350px" }}>

              <table className="table table-sm mb-0">
                <thead className="sticky-top" style={{ zIndex: '1000' }}>
                  <tr>
                    {CASE_DETAIL_HEADER.map((tableHeader: any, index: number) => (
                      <th
                        key={index}
                        className="text-center"
                        scope="col"
                        onClick={tableHeader.value !== '' ? () => changeIdOrder(tableHeader.value) : undefined}
                      >
                        <span
                          role={tableHeader.value === '' ? "textbox" : "button"}
                          className={
                            tableHeader.value === '' ?
                              'fw-bold fs-6 lh-base' :
                              'p-0 fw-bold text-white text-decoration-underline'
                          }
                        >
                          {tableHeader.label}
                          {queryParams.sort_by === tableHeader.value ? (
                            <i className={`bi ${queryParams.direction === 'desc' ? 'bi-caret-up-fill' : 'bi-caret-down-fill'}`}></i>
                          ) : null}
                        </span>
                      </th>
                    ))}
                  </tr>
                </thead>

                <tbody className="table-group-divider">
                  {CaseDetailListType &&
                    CaseDetailListType.map((item, index) => (
                      <tr key={index} className="align-middle">
                        <td className="text-center">
                          <button className="btn btn-primary text-nowrap" onClick={() => item.rx_cvge !== "" && openModal(item.case_id)}>
                            {item.case_label || ""}
                          </button>
                        </td>
                        <td className="text-center">
                          {userData &&
                            <>
                               {!HIDE_PATEINT_DOB_INITIALS.includes(userData.email) ? (
                                <>
                                  <Link
                                    to={{
                                      pathname: baseUrl,
                                      search: objectToQueryString({
                                        search_str: item.patient_id,
                                      })
                                    }}
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="right"
                                    reloadDocument
                                    className="link-underline link-underline-opacity-0 link-offset-0-hover link-underline-opacity-75-hover"
                                    //title={item && `Patient Initials: ${item.patient_Initials} \nDOB: ${item.patient_DOB}`}
                                    title={
                                      item
                                        ? (() => {
                                          const dob = new Date(item.patient_DOB);
                                          const ageDifMs = Date.now() - dob.getTime();
                                          const ageDate = new Date(ageDifMs);
                                          const age = Math.abs(ageDate.getUTCFullYear() - 1970);
                                          const isPediatric = age < 18;

                                          return `Patient Initials: ${item.patient_Initials}\nDOB: ${item.patient_DOB}${isPediatric ? '\nPediatric' : ''
                                            }`;
                                        })()
                                        : ''
                                    }
                                  >
                                    {item?.patient_id}
                                  </Link>
                                  {item && isMobileOrTablet() &&
                                    <i
                                      className="bi bi-exclamation-circle-fill info-icon ms-2"
                                      id={`case_patient_toolTip-${item.case_id}`}
                                      onClick={() => changeInfoIconIndex(infoIconIndex !== index ? index : -1)}
                                      ref={toggleIconRef}
                                    >
                                      <div
                                        className={`info-icon-detail bg-dark ${infoIconIndex === index ? "d-block" : "d-none"}`}
                                        dangerouslySetInnerHTML={{
                                          __html: `<p class="m-0 text-start">Patient Initials: ${item.patient_Initials}</p>  <p class="m-0 text-start">DOB: ${item.patient_DOB}</p>`
                                        }}
                                      ></div>
                                    </i>
                                  }
                                </>
                              )  : (
                                <Link
                                  to={{
                                    pathname: baseUrl,
                                    search: objectToQueryString({
                                      search_str: item.patient_id,
                                    })
                                  }}
                                  reloadDocument
                                  className="link-underline link-underline-opacity-0 link-offset-0-hover link-underline-opacity-75-hover"
                                >
                                  {item?.patient_id}
                                </Link>
                              )}
                            </>
                          }
                        </td>
                        <td className="text-center">{item?.bi_only}</td>
                        <td className="text-center">{item?.qty}</td>
                        <td className="text-center">{item?.refills}</td>
                        <td className='text-center'>{item.received}</td>
                        <td className="text-center">{item?.bi_completed}</td>
                        <td className="text-center">{item?.transferred}</td>
                        <td className="text-center">{item?.scheduled}</td>
                        <td className="text-center">{item?.shipped}</td>
                        <td className="text-center">{item?.pharmacy}</td>
                        <td className='text-center'>{item.payer}</td>
                        <td className={`text-center align-middle text-white ${item && item.status_color ? item.status_color : 'bg-blue-lt'}`}
                          style={{ minWidth: "200px" }}>
                          {item.case_status}
                        </td>
                        <td className="text-center">{item?.rx_cvge}</td>
                        <td className="text-center">
                          {item.clinical_received ?
                            (item.clinical_received.toLowerCase() === 'y' && isNotOlderThanOneYear(item.clinical_received_date || '') ? 'Y' : 'N')
                            : 'N'}
                        </td>
                        <td className="text-center">{item?.rx_pa.data}</td>
                        <td className="text-center">
                          
                          {location.pathname.includes("/doctor_stats") ? ( 
                            (<Link
                              to={{
                                pathname: `/doctor_stats/${item.provider.doctor_id}`,
                                search: objectToQueryString({
                                type: "doctor_stats",
                                start_date: searchParams.start_date,
                                end_date: searchParams.end_date,
                                age_group: searchParams.age_group,
                                role:'doctor',
                                p_id: params.get("p_id"),
                                id: item.provider.doctor_id,
                              })
                            }}
                            reloadDocument
                            data-bs-toggle="tooltip"
                            data-bs-placement="right"
                            className="link-underline link-underline-opacity-0 link-offset-0-hover link-underline-opacity-75-hover"
                            title={item && item.provider ? `${(item.provider.practice_name ? `Practice: ${item.provider.practice_name}` : '')}${(item.provider.address ? `\nAddress: ${item.provider.address}` : '')}${(item.provider.phone ? `\nPhone: ${item.provider.phone}` : '')}${(item.provider.fax ? `\nFax: ${item.provider.fax}` : '')}` : ''}
                          >
                            {item?.provider.doc_name}
                          </Link>)
                          ):( location.pathname.includes("/practice_stats") ?
                            (<Link
                              to={{
                                pathname: `/doctor_stats/${item.provider.doctor_id}`,
                                search: objectToQueryString({
                                type: "doctor_stats",
                                start_date: searchParams.start_date,
                                end_date: searchParams.end_date,
                                age_group: searchParams.age_group,
                                role:'doctor',
                                p_id: params.get("p_id"),
                                id: item.provider.doctor_id,
                              })
                            }}
                            reloadDocument
                            data-bs-toggle="tooltip"
                            data-bs-placement="right"
                            className="link-underline link-underline-opacity-0 link-offset-0-hover link-underline-opacity-75-hover"
                            title={item && item.provider ? `${(item.provider.practice_name ? `Practice: ${item.provider.practice_name}` : '')}${(item.provider.address ? `\nAddress: ${item.provider.address}` : '')}${(item.provider.phone ? `\nPhone: ${item.provider.phone}` : '')}${(item.provider.fax ? `\nFax: ${item.provider.fax}` : '')}` : ''}
                          >
                            {item?.provider.doc_name}
                          </Link>)  :
                           (<Link
                              to={{
                                pathname: `/doctor_stats/${item.provider.doctor_id}`,
                                search: objectToQueryString({
                                type: "doctor_stats",
                                start_date: searchParams.start_date,
                                end_date: searchParams.end_date,
                                age_group: searchParams.age_group,
                                role:'doctor',
                                p_id: id,
                                id: item.provider.doctor_id,
                              })
                            }}
                            reloadDocument
                            data-bs-toggle="tooltip"
                            data-bs-placement="right"
                            className="link-underline link-underline-opacity-0 link-offset-0-hover link-underline-opacity-75-hover"
                            title={item && item.provider ? `${(item.provider.practice_name ? `Practice: ${item.provider.practice_name}` : '')}${(item.provider.address ? `\nAddress: ${item.provider.address}` : '')}${(item.provider.phone ? `\nPhone: ${item.provider.phone}` : '')}${(item.provider.fax ? `\nFax: ${item.provider.fax}` : '')}` : ''}
                          >
                            {item?.provider.doc_name}
                          </Link>)
                          ) 
                          }
                        </td>
                      </tr>
                    ))
                  }
                </tbody>
              </table>

            </div>
          </div>
        </div>

        <div className="col-8">
          {showingModal ? <StepperModal caseId={selectedCaseId} onClick={() => {
            setModal(false);
            updateSelectedCaseId(0)
          }} /> : null}
        </div>
      </div>
    </>
  );
};

export default CaseDetail;

